import { Button } from 'components/button/Button'
import { SAddLegacyContactModal, SImage } from './ContactInfoModal.styled'
import { useModal } from 'components/modal/Modal'
import { Picture } from 'components/picture/Picture'
import { BlockSpinner } from 'components/spinner/Spinner'
import { Text, Title } from 'components/Typography'
import { useDynamicTranslations } from 'utils/i18n/useDynamicTranslations'

const TRUSTED_DESCRIPTION =
  'A friend or family member who can only access information in your account based on what you decide. You can also choose to only share access now (e.g. to important documents), never (e.g. if you prefer to keep private), or after you pass away (e.g. so they can take action on your behalf with various accounts).'

const LEGACY_DESCRIPTION =
  'A friend, family member or legal representative who is empowered to contact various sites, services, and accounts on your behalf after you pass away and access selected information. This person plays a critical role in determining what happens to all your digital memories and assets.'

const ContactInfoModal = (props: { isLegacy?: boolean; onClose: () => void }) => {
  const { t, isLoading } = useDynamicTranslations('trusted_contact')
  if (isLoading) return <BlockSpinner />
  return (
    <SAddLegacyContactModal>
      <Picture imageComponent={SImage} imageKey={'illustrations/deputy'} sizes={'250px'} />
      <Title variant="h7" as="h5">
        {props.isLegacy
          ? t('trusted_contact.contact_info_modal_title_legacy')
          : t('trusted_contact.contact_info_modal_title_trusted')}
      </Title>
      <Text>{props.isLegacy ? LEGACY_DESCRIPTION : TRUSTED_DESCRIPTION}</Text>
      <Button type="button" size="large" onClick={props.onClose}>
        {t('trusted_contact.contact_info_modal_close_button')}
      </Button>
    </SAddLegacyContactModal>
  )
}

export const useContactInfoModal = (isLegacy?: boolean) => {
  const [infoModal, openInfoModal, closeInfoModal] = useModal(
    ({ isOpen, close }) => isOpen && <ContactInfoModal onClose={close} isLegacy={isLegacy} />,
    { modalCss: { maxWidth: 480 }, modalContentCss: { padding: '2rem' } }
  )

  return [infoModal, openInfoModal, closeInfoModal] as const
}
